// scrollear_seccion.js
export const scrollearSeccion = (id) => {
  const seccion = document.getElementById(id);
  if (seccion) {
    seccion.scrollIntoView({ behavior: "smooth" });
  }
};
